// Workstream: Shop (physical decks, checkout, order status).
// Add this workstream's pages here; main.tsx renders every entry.
import type { AppRoute } from '../../routes';
import { ProductPage } from './ProductPage';
import { ShopPage } from './ShopPage';
import { ThanksPage } from './ThanksPage';

export const routes: AppRoute[] = [
  { path: '/shop', element: <ShopPage /> },
  { path: '/shop/thanks', element: <ThanksPage /> },
  { path: '/shop/:slug', element: <ProductPage /> },
];
